import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-background-50">
                叮咚漫画
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              叮咚漫画网提供韩漫免费阅读服务，涵盖韩国漫画在线和高清韩漫大全，让您轻松享受优质漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              漫画分类
            </h4>
            <div className="space-y-2">
              <Link to="/category/romance" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恋爱漫画</Link>
              <Link to="/category/fantasy" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">奇幻漫画</Link>
              <Link to="/category/action" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">动作漫画</Link>
              <Link to="/category/thriller" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">悬疑漫画</Link>
              <Link to="/category/horror" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恐怖漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              热门推荐
            </h4>
            <div className="space-y-2">
              <Link to="/article/1" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">女神降临</Link>
              <Link to="/article/2" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">看脸时代</Link>
              <Link to="/article/3" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">神之塔</Link>
              <Link to="/article/10" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">全知读者视角</Link>
              <Link to="/article/8" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">与神同行</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              网站信息
            </h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/about" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              <Link to="/category/all" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">全部漫画</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 叮咚漫画网 - 韩漫免费阅读平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">使用条款</a>
            <a href="#" className="text-sm text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}